import Vue from 'vue'
import Router from 'vue-router'
import cookie from '@/utils/cookie'
import store from '@/store'
import * as types from '@/store/mutation-types'

// import { routerMode } from '@/config/env'
import c404 from '@/components/common/404'
import c403 from '@/components/common/403'
const Header = () => import('@/components/common/MyHeader');
const Main = () => import('@/components/system/main.vue');
const AboutUs = () => import('@/components/system/aboutUs.vue');
const BirdTracing = () => import('@/components/system/birdTracing.vue');
const OverseasRegist = () => import('@/components/system/overseasRegist.vue');
const ProductVerification = () => import('@/components/system/productVerification.vue');
const NewsArea = () => import('@/components/system/newsArea.vue');
const DataArea = () => import('@/components/system/dataArea.vue');
const DownloadArea = () => import('@/components/system/downloadArea.vue');
const Footer = () => import('@/components/common/MyFooter.vue');
const details = ()=> import('@/components/system/newsDetails.vue')

Vue.use(Router)
var router = new Router({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
        { path: '*', component: c404, meta: { showHeader: false } },
        {
            path: '/',
            name: 'index',
            components: {
                header: Header,
                chart: Main,
                footer:Footer
            },
            meta: { title: '首页', headerSelected: 0 }
        },
        {
            path: '/index',
            name: 'main',
            components: {
                header: Header,
                chart: Main,
                footer:Footer
            },
            meta: { title: '首页', headerSelected: 0 }
        },
        {
            path: '/aboutUs',
            name: 'AboutUs',
            components: {
                header: Header,
                chart: AboutUs,
                footer:Footer
            },
            meta: { title: '关于我们', headerSelected: 0 }
        },
        {
            path: '/birdTracing',
            name: 'BirdTracing',
            components: {
                header: Header,
                chart: BirdTracing,
                footer:Footer
            },
            meta: { title: '溯源燕窝'}
        },
        {
            path: '/productVerification',
            name: 'ProductVerification',
            components: {
                header: Header,
                chart: ProductVerification,
                footer:Footer
            },
            meta: { title: '产品认证'}
        },
        {
            path: '/overseasRegist',
            name: 'OverseasRegist',
            components: {
                header: Header,
                chart: OverseasRegist,
                footer:Footer
            },
            meta: { title: '境外注册'}
        },
        {
            path: '/newsArea',
            name: 'NewsArea',
            components: {
                header: Header,
                chart: NewsArea,
                footer:Footer
            },
            meta: { title: '新闻专区'}
        },{
            path: '/dataArea',
            name: 'DataArea',
            components: {
                header: Header,
                chart: DataArea,
                footer:Footer
            },
            meta: { title: '资料专区'}
        },{
            path: '/downloadArea',
            name: 'DownloadArea',
            components: {
                header: Header,
                chart: DownloadArea,
                footer:Footer
            },
            meta: { title: '下载专区'}
        },{
            path: '/newsDetails',
            name: 'newsDetails',
            components: {
                header: Header,
                chart: details,
                footer:Footer
            },
            meta: { title: '文章详情页'}
        },
        {
            path: '/404',
            component: c404
        },
        {
            path: '/403',
            component: c403
        },
        {
            path: '*',
            redirect: '/404'
        },
    ]
});
router.beforeEach(function (to, from, next) {
    document.body.scrollTop = 0;
    // store.commit(types.SET_LOADING, { loading: false });
    next();
})
// router.afterEach((to,from,next) => {
//     window.scrollTo(0,0);
// })
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js